export default "__VITE_PUBLIC_ASSET__17dbf4eb__"